import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionValidDto } from '@dto';
import { RequestMethodEnum, RequestOptions } from '@model';
import { GenericService } from './generic.service';

const SESSIONS_VALIDATE_ENDPOINT = 'api/v1/sessions/validate';

@Injectable()
export class SessionService {
  constructor(private resourceService: GenericService) {}

  validateSession$(): Observable<SessionValidDto> {
    const options: RequestOptions<undefined, SessionValidDto> = {
      method: RequestMethodEnum.GET,
      path: SESSIONS_VALIDATE_ENDPOINT,
    };
    return this.resourceService.request(options);
  }
}
